import { GET } from "./api";

// Fetches the weekly controls. On failure returns null, so the screens keep
// showing the actions and the API remains the one enforcing the lock.
const loadWeekControls = async () => {
  try {
    const weeks = await GET("controls/weeks");
    return Array.isArray(weeks) ? weeks : null;
  } catch (e) {
    console.log(e);
    return null;
  }
};

// A date is locked when its week is closed or has no control registered,
// the same rule the API applies when creating a record.
const isDateLocked = (weeks, workedDate) => {
  if (!weeks || !workedDate) return false;
  const day = String(workedDate).split("T")[0];
  const week = weeks.find((w) => w.startDate <= day && day <= w.endDate);
  return !week || !week.status;
};

export { loadWeekControls, isDateLocked };
